"use client";

// src/components/LogoFull.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var LogoFull = forwardRef((props, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    ref,
    fill: "currentColor",
    height: "1em",
    viewBox: "0 0 280 40",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M39.76.168V1.19L22.78 19.946 39.76 38.7v1.023h-8.73l-14.8-16.095H7.366v16.095H0V.168h7.365v16.095h8.866L31.032.168h8.73zM43.922.168h7.365v39.555h-7.365V.168zM89.07.168v7.365H66.973c-.818 0-1.5.682-1.5 1.5V39.72h-7.365V9.033A8.85 8.85 0 0166.975.166h22.097l-.002.002zM141.925.168L120.1 39.723h-7.364L90.911.168h8.525l16.982 31.236L133.467.168h8.458zM187.14 9.035v30.689h-31.372a8.848 8.848 0 01-8.867-8.867V16.264h32.872V9.035c0-.818-.681-1.5-1.499-1.5h-31.373V.172h31.373a8.848 8.848 0 018.866 8.866v-.002zm-7.365 14.594h-25.506v7.228c0 .818.681 1.5 1.499 1.5h24.005v-8.73l.002.002zM233.244 9.034v30.69h-7.365V9.033c0-.817-.681-1.499-1.499-1.499h-22.506c-.818 0-1.499.682-1.499 1.5v30.688h-7.365V.168h31.372a8.848 8.848 0 018.867 8.866h-.005zM270.96.168a8.848 8.848 0 018.867 8.866V30.86a8.848 8.848 0 01-8.867 8.866h-22.506a8.848 8.848 0 01-8.866-8.866V9.034a8.85 8.85 0 018.866-8.866h22.506zm-22.506 7.365c-.817 0-1.499.681-1.499 1.5v21.824c0 .817.682 1.499 1.499 1.499h22.506c.818 0 1.5-.682 1.5-1.5V9.033c0-.818-.682-1.5-1.5-1.5h-22.506z" })
  }
));
LogoFull.displayName = "LogoFull";
var LogoFull_default = LogoFull;

export {
  LogoFull,
  LogoFull_default
};
